import { all, takeEvery, put, call } from 'redux-saga/effects';
import ApiInstance from '../../../../../helpers/apiInstance';
import actions from './actions';
import { tableConfig } from '../../../../../settings/index';
import { sendRequest } from '../../../../../helpers/saga';
import { logger } from '../../../../../helpers/logger';
import notifications from '../../../../../redux/notifications/actions';
import { executeAction } from '../../../../../helpers/api';
import { t } from '../../../../../i18n';

function* loadDataRequest({ payload }) {
  try {
    const {
      page = 1,
      pageSize = tableConfig.unlimited,
      column,
      order,
      filter = '',
      id,
      clientType,
      parent_id = false,
    } = payload;
    const api = new ApiInstance(`${clientType}/:id/accreditations`);

    const result = yield call(
      sendRequest,
      api.get,
      { search: { page, pageSize, column, order, filter, parent_id }, pathParams: { id } },
      notifications.REQUEST_ERROR,
    );

    if (result?.status === 200 && result?.data) {
      const { records: data } = result.data;

      yield put(actions.loadDataSuccess({ data, parent_id }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* deleteAccreditationRequest({ payload }) {
  try {
    const { method, url, id, clientType, parent_id } = payload;

    const result = yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);

    if (result) {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.removed_successfully', {
            item: t('dash.clients.components.accreditations.accreditation_label'),
          }),
        }),
      );
      yield put(actions.loadData({ id, clientType, parent_id }));
    }
  } catch (error) {
    logger.error(error);
  }
}

export { loadDataRequest, deleteAccreditationRequest };
export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD_DATA_REQUEST, loadDataRequest),
    takeEvery(actions.DELETE_REQUEST, deleteAccreditationRequest),
  ]);
}
